import api from './api';
import { LOADS_API_URL } from '../../env';

const loadBoardUrl = LOADS_API_URL;

const getMetadataUrl = `${loadBoardUrl}/Metadata/GetApplicationMetadata`;
const getUserProfileSettingsUrl = `${loadBoardUrl}/Metadata/GetUserProfileSettings`;
const postUserProfileSettingsUrl = `${loadBoardUrl}/Metadata/PostUserProfileSettings`;

export async function getMetadata() {
  const options = {
    url: getMetadataUrl,
  };
  return api.get(options);
}

export async function getUserProfileSettings() {
  const options = {
    url: getUserProfileSettingsUrl,
  };
  return api.get(options);
}

export async function postUserProfileSettings(payload) {
  const options = {
    url: postUserProfileSettingsUrl,
    data: {
      ...payload,
    },
  };
  return api.post(options);
}
